import React from 'react'
import PropTypes from 'prop-types';
import DefaultValueHint from './DefaultValueHint';

export default function FieldLabel({ field, showLabel, currentValue }) {
  if (showLabel) {
    return (
      <div className="display-inline-block">
        <label>
          {field.name}
          {field.required &&
            <span className="text-danger"> *</span>
          }
          <DefaultValueHint field={field} currentValue={currentValue} />
        </label>
      </div>
    )
  }

  return (
    <div>
      <DefaultValueHint field={field} currentValue={currentValue} />
    </div>
  )
}

FieldLabel.propTypes = {
  field: PropTypes.object.isRequired,
  showLabel: PropTypes.bool.isRequired,
  currentValue: PropTypes.string
}
